export const DEFAULT_VALUE_STYLE = {
  Point: {
    icon: {
      icon_type: 'shape',
      shape_type: 'square',
      fill: '#000000',
      stroke: '#000000',
      'fill-opacity': 1,
      image: null,
    },
    opacity: 1,
  },
  Line: {
    stroke: '#000000',
    'stroke-opacity': 1,
    'stroke-width': 1,
    'stroke-dasharray': [],
  },
  Text: {
    fill: '#000000',
    'font-size': 10,
    label: 'name',
    'font-style': 'normal',
    'fill-opacity': 1,
  },
  Polygon: { fill: '#000000', 'fill-opacity': 1 },
}
export const DEFAULT_VALUE_LABEL_STYLE = {
  Point: {
    'text-size': 16,
    'text-color': '#333333',
    'text-halo-color': '#ffffff',
    'text-halo-width': 1.5,
    'text-halo-blur': 1,
    'text-offset': [0, 1],
    'text-ignore-placement': true,
    'text-font': 'Arial Regular',
  },
  Line: {
    'text-size': 16,
    'text-color': '#333333',
    'text-halo-color': '#ffffff',
    'text-halo-width': 1.5,
    'text-halo-blur': 1,
    'symbol-placement': 'line',
    'text-font': 'Arial Regular',
  },
  Polygon: {
    'text-size': 16,
    'text-color': '#333333',
    'text-halo-color': '#ffffff',
    'text-halo-width': 1.5,
    'text-halo-blur': 1,
    'text-font': 'Arial Regular',
  },
}
